import React, { useEffect, useRef, useState } from 'react'
import { ChatMessageResponse } from '../../Api/Chats/models'
import { Form, OverlayTrigger, Row, Tooltip, Dropdown, InputGroup } from 'react-bootstrap'
import { Button } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import './Styles.css'
import { useSocket } from '../../../../hooks/useSocket'
import { useTestToken } from '../../Hooks/useTestToken'
import { useAdminInfo } from '../../../../hooks/useAdminInfo'
import { SingleAnonChat } from '../../Api/AnonChats/models'
import { getAnonChatMessages } from '../../Api/AnonChats/Chats'
import { ShowImageInModal } from '../../../../Components/ShowImageInmodal'
import { BiImageAdd } from 'react-icons/bi'
import { useChatImageUpload } from '../../Hooks/useChatImageUpload'
import { ShowUploadedImageModal } from '../../Components/ShowUploadedImageModal'
const emojis = ['😊', '😂', '👍', '❤️', '😎', '🎮', '💰', '✨', '🔥', '👋', '😅', '🙏', '💪', '🎯', '🌟'];

export const LiveChat = ({ chat }: { chat: SingleAnonChat }) => {
    const chatMessagesRef = useRef<HTMLDivElement>(null)
    const { userInfo } = useTestToken()
    const { adminInfo } = useAdminInfo();
    const { socket } = useSocket();

    const [inputMessage, setInputMessage] = useState('')
    const [messages, setMessages] = useState<ChatMessageResponse[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [showEmojis, setShowEmojis] = useState(false);
    const [showImageInModal, setShowImageInModal] = useState(false);
    const [imageInModal, setImageInModal] = useState('');

    const { image, handleImageUpload, showImageModal, setShowImageModal } = useChatImageUpload()

    const rollDownChat = () => {
        if (chatMessagesRef.current) {
            chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight
        }
    }

    const fetchChatMessages = async () => {
        const res = await getAnonChatMessages({ page: 1, chatId: chat.id })
        if (res) {
            setMessages(res?.messages)
            setCurrentPage(res?.currentPage)
            setHasMore(res?.hasMore)
        }
    }

    const fetchMoreChatMessages = async () => {
        const res = await getAnonChatMessages({ page: currentPage + 1, chatId: chat.id })
        if (res) {
            setMessages([...res?.messages, ...messages])
            setCurrentPage(res?.currentPage)
            setHasMore(res?.hasMore)
        }
    }

    const sendMessage = () => {
        const msg = inputMessage.trim()
        if (msg) {
            setInputMessage("");
            if (socket) {
                const payload = {
                    message: msg,
                    ChatId: chat.id,
                    type: 'text',
                    creatorType: 'admin',
                    PlayerId: chat.PlayerId,
                    OwnerId: chat.OwnerId,
                    UserId: userInfo?.id
                }
                socket.emit(`create-anon-message`, payload)
            }
        }
    };

    const insertEmoji = (emoji: string) => {
        setInputMessage(prev => prev + emoji);
    };


    useEffect(() => {
        fetchChatMessages()
        setTimeout(() => {
            rollDownChat()
        }, 100)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chat])

    useEffect(() => {
        if (!socket) return;
        if (socket) {
            socket.on(`update-anon-messages-${chat.id}`, (data: { message: ChatMessageResponse, ChatId: string }) => {
                console.log(chat.id, data?.ChatId)
                if (data?.message && data?.ChatId === chat.id) {
                    setMessages([...messages, data?.message])
                    setTimeout(() => {
                        rollDownChat()
                    }, 300)
                    if (socket) {
                        socket.emit(`seen-anon-chat`, {
                            ChatId: chat.id,
                            OwnerId: adminInfo?.id,
                            role: 'user',
                        });
                    }
                }
            });
        }
        return () => {
            socket.off(`update-anon-messages-${chat.id}`);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket, chat, messages]);

    return (
        <>
            <ShowUploadedImageModal
                image={image}
                show={showImageModal}
                handleClose={() => setShowImageModal(false)}
                playerId={chat.PlayerId}
                chatId={chat.id}
            />

            <div className="border border-secondary rounded pt-4 h-100 bg-chat">
                <ShowImageInModal show={showImageInModal} handleClose={() => setShowImageInModal(false)} image={imageInModal} />
                <div className="text-center text-primary">
                    Chat con Anónimo
                </div>
                <hr />
                <div className="mb-3 p-3" style={{ minHeight: "65vh", maxHeight: "65vh", overflowY: "auto", display: "flex", flexDirection: "column" }} ref={chatMessagesRef}>
                    {hasMore && <div className="text-center text-xs text-secondary mb-0 pb-1 mb-1" role="button" onClick={fetchMoreChatMessages}>
                        Cargar más mensajes
                    </div>
                    }
                    {messages?.map((msg, idx) => (
                        <div className="mb-2" style={{ display: "flex", flexDirection: "column" }} key={idx}>
                            {msg.creatorType === 'player' ?
                                (<React.Fragment key={idx}>
                                    <div className={`text-start text-break`} style={{ alignSelf: "flex-start" }}>
                                        <div className={`rounded-3 p-1 bg-secondary-light ${msg.type === 'text' ? 'px-2' : ''}`} style={{ marginRight: '50px' }}>

                                            {msg.type === 'image' &&
                                                <img
                                                    role="button"
                                                    onClick={() => {
                                                        setImageInModal(`${process.env.REACT_APP_API}${msg.message}`)
                                                        setShowImageInModal(true)
                                                    }}
                                                    src={`${process.env.REACT_APP_API}${msg.message}`}
                                                    alt="imagen"
                                                    className="rounded-3"
                                                    style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                                                />
                                            }

                                            {msg.type === 'text' &&
                                                msg.message
                                            }

                                        </div>
                                        <div className="text-xs text-start text-secondary">
                                            {new Date(msg.createdAt).toLocaleString()}
                                        </div>
                                    </div>
                                </React.Fragment>)
                                :
                                (<React.Fragment key={idx}>
                                    <OverlayTrigger
                                        placement={"left"}
                                        overlay={<Tooltip>Enviado por {msg?.User?.name}</Tooltip>}
                                    >
                                        <div className={`text-end text-break`} style={{ alignSelf: "flex-end" }}>
                                            <div className="bg-primaryy text-end rounded-3 p-1 px-2" style={{ marginLeft: '50px' }}>
                                                {msg.type === 'image' &&
                                                    <img
                                                        role="button"
                                                        onClick={() => {
                                                            setImageInModal(`${process.env.REACT_APP_API}${msg.message}`)
                                                            setShowImageInModal(true)
                                                        }}
                                                        src={`${process.env.REACT_APP_API}${msg.message}`}
                                                        alt="imagen"
                                                        className="rounded-3"
                                                        style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                                                    />
                                                }

                                                {msg.type === 'text' &&
                                                    msg.message
                                                }
                                            </div>
                                            <div className="text-xs text-end text-secondary">
                                                {new Date(msg.createdAt).toLocaleString()}
                                            </div>
                                        </div>
                                    </OverlayTrigger>

                                </React.Fragment>)
                            }
                        </div>
                    ))}
                </div>
                <hr />

                <InputGroup className="mt-3 d-flex gap-2 py-3">
                    <div className="d-flex w-100 gap-2">
                        <Dropdown show={showEmojis} onToggle={(isOpen) => setShowEmojis(isOpen)} className="d-flex justify-content-center" >
                            <Dropdown.Toggle
                                variant="outline-secondary"
                                className="p-2 mm"
                                style={{ minWidth: '40px' }}
                            >
                                😊
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="bg-dark p-2" style={{ maxWidth: '200px' }}>
                                <div className="d-flex flex-wrap gap-2">
                                    {emojis.map((emoji, index) => (
                                        <span
                                            key={index}
                                            role="button"
                                            onClick={() => insertEmoji(emoji)}
                                            style={{ fontSize: '20px' }}
                                        >
                                            {emoji}
                                        </span>
                                    ))}
                                </div>
                            </Dropdown.Menu>
                        </Dropdown>


                        <Form.Control
                            type="text"
                            placeholder="Escribe un mensaje..."
                            value={inputMessage}
                            onChange={(e) => setInputMessage(e.target.value)}
                            className="text-light py-2"
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    sendMessage();
                                }
                            }}
                        />
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>Añadir imagen</Tooltip>}
                        >
                            <Button variant="secondary" className="rounded-3 p-1 px-2" onClick={() => document.getElementById('fileUpload')?.click()}>
                                <BiImageAdd size={20} />
                                <input
                                    type="file"
                                    id="fileUpload"
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    onChange={(e) => {
                                        if (e.target.files && e.target.files[0]) {
                                            handleImageUpload(e)
                                            setShowImageModal(true)
                                            e.target.value = '';
                                        }
                                    }}
                                />
                            </Button>
                        </OverlayTrigger>

                        <Button variant="primary rounded-3" onClick={sendMessage}>
                            ➤
                        </Button>
                    </div>
                </InputGroup>
            </div>
        </>
    )
}
